import React, { useState, useEffect } from 'react'
import {
  Table, Checkbox
} from 'antd'
const adminManage = (props) => {
  const {
    setDataAdmin,
    dataEdit,
    menuAdmin,
    setMenuAdmin,
    word,
  } = props
  const SYNC_BU_CODE = 'adm_sync_business'
  const [stateChange, setStateChange] = useState(false)
  const [menuCheck, setMenuCheck] = useState({
    create: false,
    read: false,
    delete: false,
  })
  useEffect(() => {
    const normalizeMenuAdmin = menuAdmin.map((item) => {
      if (item.code === SYNC_BU_CODE) {
        item.permission.create = false
        item.permission.update = false
        item.permission.delete = false
      }
      return item
    })
    setDataAdmin(normalizeMenuAdmin)
  }, [menuAdmin])
  useEffect(() => {
    if (dataEdit.role_id) {
      setStateChange(true)
      menuAdmin.map((menu) => {
        dataEdit.permission?.map((data) => {
          if (menu.id === data.menu_id) {
            Object.keys(data).map(function (key) {
              menu.permission[key] = data[key]
            })
            if (menu.code === SYNC_BU_CODE) {
              menu.permission.create = false
              menu.permission.update = false
              menu.permission.delete = false
            }
          }
        })
      })
      setMenuAdmin([...menuAdmin])
    }
  }, [dataEdit])
  const dataSource = menuAdmin.map((item) => ({
    id: item.id,
    code: item.code,
    title: item.name,
    permission: item.permission,
  }))
  const columns = [
    {
      title: <h5>{word['Menu']}</h5>,
      dataIndex: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
      width: 190,
      ellipsis: true,
      render: (text, record, index) => {
        return <span>{record.title}</span>
      },
    },
    {
      title: (
        <Checkbox
          id="all_create_edit_admin"
          key="1"
          checked={menuCheck.create}
          value={'Menu_Create'}
          onChange={(e) => onChange(e, menuAdmin)}
        >
          {word['Create_Edit']}
        </Checkbox>
      ),
      dataIndex: 'title',
      width: 120,
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <Checkbox
            id={`create_edit_admin` + index}
            value={'create'}
            checked={record.permission.create}
            disabled={record.code === SYNC_BU_CODE}
            onChange={(e) => onChange(e, record)}
          />
        )
      },
    },
    {
      title: (
        <Checkbox
          id="all_view_admin"
          key="2"
          checked={menuCheck.read}
          value={'Menu_View'}
          onChange={(e) => onChange(e, menuAdmin)}
        >
          {word['View']}
        </Checkbox>
      ),
      dataIndex: 'title',
      width: 100,
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <Checkbox
            id={`view_admin` + index}
            value={'view'}
            checked={record.permission.read}
            onChange={(e) => onChange(e, record)}
          />
        )
      },
    },
    {
      title: (
        <Checkbox
          id="all_delete_admin"
          key="3"
          checked={menuCheck.delete}
          value={'Menu_Delete'}
          onChange={(e) => onChange(e, menuAdmin)}
        >
          {word['Delete']}
        </Checkbox>
      ),
      dataIndex: 'title',
      width: 100,
      ellipsis: true,
      render: (text, record, index) => {
        return (
          <Checkbox
            id={`delete_admin` + index}
            value={'delete'}
            checked={record.permission.delete}
            disabled={record.code === SYNC_BU_CODE}
            onChange={(e) => onChange(e, record)}
          />
        )
      },
    },
  ]
  useEffect(() => {
    if (stateChange === true) {
      let allCheckCreate = true
      let allCheckRead = true
      let allCheckDelete = true
      menuAdmin.map((item) => {
        if (item.code === SYNC_BU_CODE) {
          return
        }
        if (item.permission.create === false) {
          allCheckCreate = false
        }
        if (item.permission.read === false) {
          allCheckRead = false
        }
        if (item.permission.delete === false) {
          allCheckDelete = false
        }
      })
      if (allCheckCreate === false) {
        setMenuCheck((prev) => ({
          ...prev,
          create: false,
        }))
      } else {
        setMenuCheck((prev) => ({
          ...prev,
          create: true,
          update: true,
        }))
      }
      if (allCheckRead === false) {
        setMenuCheck((prev) => ({
          ...prev,
          read: false,
        }))
      } else {
        setMenuCheck((prev) => ({
          ...prev,
          read: true,
        }))
      }
      if (allCheckDelete === false) {
        setMenuCheck((prev) => ({
          ...prev,
          delete: false,
        }))
      } else {
        setMenuCheck((prev) => ({
          ...prev,
          delete: true,
        }))
      }
    }
    setStateChange(false)
  }, [stateChange])
  const handleCheckHeaderMenu = (e) => {
    setStateChange(true)
    if (e.target.value === 'Menu_Create') {
      setMenuCheck((prev) => ({
        ...prev,
        create: !menuCheck.create,
      }))
      menuAdmin.map((item) => {
        if (item.code === SYNC_BU_CODE) {
          return
        }
        setMenuAdmin([
          ...menuAdmin,
          (item.permission.create = e.target.checked),
          (item.permission.update = e.target.checked),
          (item.permission.read = true),
        ])
      })
    }
    if (e.target.value === 'Menu_View') {
      setMenuCheck((prev) => ({
        ...prev,
        read: !menuCheck.read,
      }))
      menuAdmin.map((item) => {
        if (e.target.checked === false) {
          setMenuAdmin([
            ...menuAdmin,
            (item.permission.read = e.target.checked),
            (item.permission.create = e.target.checked),
            (item.permission.update = e.target.checked),
            (item.permission.delete = e.target.checked),
          ])
        } else {
          setMenuAdmin([...menuAdmin, (item.permission.read = e.target.checked)])
        }
      })
    }
    if (e.target.value === 'Menu_Delete') {
      setMenuCheck((prev) => ({
        ...prev,
        delete: !menuCheck.delete,
      }))
      menuAdmin.map((item) => {
        if (item.code === SYNC_BU_CODE) {
          return
        }
        setMenuAdmin([
          ...menuAdmin,
          (item.permission.delete = e.target.checked),
          (item.permission.read = true),
        ])
      })
    }
  }
  const onChange = (e, record) => {
    handleCheckHeaderMenu(e)
    if (e.target.value === 'create') {
      menuAdmin.map((item) => {
        if (record.id === item.id) {
          setMenuAdmin([
            ...menuAdmin,
            (item.permission.create = !item.permission.create),
            (item.permission.update = item.permission.create),
            (item.permission.read = true),
          ])
        }
      })
    } else if (e.target.value === 'view') {
      menuAdmin.map((item) => {
        if (record.id === item.id) {
          setMenuAdmin([
            ...menuAdmin,
            (item.permission.read = !item.permission.read),
            (item.permission.create = false),
            (item.permission.update = false),
            (item.permission.delete = false),
          ])
        }
      })
    } else {
      menuAdmin.map((item) => {
        if (record.id === item.id) {
          setMenuAdmin([
            ...menuAdmin,
            (item.permission.delete = !item.permission.delete),
            (item.permission.read = true),
          ])
        }
      })
    }
    setMenuAdmin([...menuAdmin])
  }
  return <Table columns={columns} dataSource={dataSource} pagination={false} />
}

export default adminManage
